import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1F3A2C', light: '#3A5C48', contrastText: '#F7F2E7' },
    secondary: { main: '#C98A2E', contrastText: '#1F2A22' },
    background: { default: '#F7F1E5', paper: '#FBF7EE' },
    text: { primary: '#1B2A1F', secondary: '#5A6A5C' },
    success: { main: '#6E8C4B' },
    warning: { main: '#C98A2E' },
    error: { main: '#B23A2F' },
    divider: '#DCD3BD'
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: "'Inter', system-ui, sans-serif",
    h1: { fontFamily: "'Fraunces', Georgia, serif", letterSpacing: '-0.02em', fontWeight: 600 },
    h2: { fontFamily: "'Fraunces', Georgia, serif", letterSpacing: '-0.02em', fontWeight: 600 },
    h3: { fontFamily: "'Fraunces', Georgia, serif", letterSpacing: '-0.02em', fontWeight: 600 },
    h4: { fontFamily: "'Fraunces', Georgia, serif", letterSpacing: '-0.02em', fontWeight: 600 },
    h5: { fontFamily: "'Fraunces', Georgia, serif", fontWeight: 600 },
    h6: { fontFamily: "'Fraunces', Georgia, serif", fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 500 },
    overline: { letterSpacing: '0.18em', fontWeight: 600 }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10 }
      }
    }
  }
});

export const lodgeColors = {
  moss: '#6E8C4B',
  brass: '#C98A2E',
  clay: '#B05D3D',
  primary: '#1F3A2C',
  primaryGlow: '#3A5C48',
  accent: '#C98A2E'
};
